import type React from 'react';

import { useGetGroups } from '@vlabs/api/artemy/client';
import type { DepartmentId } from '@vlabs/api/artemy/model';

import { DepartmentStreamGroup } from '@vlabs/monokit/entities/streams';
import { AttachDepartmentGroupsButton, DetachDepartmentGroupsIconButton } from '@vlabs/monokit/features';

import { useDepartmentStreamGroupListTranslation } from './i18n';
import { FoldableEntity } from '../../../shared/ui/foldable-entity';
import type { FoldableEntityProps } from '../../../shared/ui/foldable-entity';

interface DepartmentStreamGroupListProps extends Pick<FoldableEntityProps, 'actions'> {
  departmentId: DepartmentId;
}

function DepartmentStreamGroupList({
  departmentId,
  ...props
}: DepartmentStreamGroupListProps): React.JSX.Element {
  const { t } = useDepartmentStreamGroupListTranslation();
  const { data } = useGetGroups({ owner_department_ids: [departmentId] });

  return (
    <FoldableEntity
      actions={<AttachDepartmentGroupsButton departmentId={departmentId} />}
      heading={t('title')}
      {...props}
    >
      {data?.groups?.map(({ group_id: groupId }) => groupId && (
        <DepartmentStreamGroup
          actions={[
            <DetachDepartmentGroupsIconButton
              groupIds={[groupId]}
              key="detach"
            />,
          ]}
          groupId={groupId}
          key={groupId}
        />
      ))}
    </FoldableEntity>
  );
}

export { DepartmentStreamGroupList };
